import { __ } from '@wordpress/i18n';

export default {
	message: __( 'Estate Grid', 'kam001-real-estate-blocks' ),
};
